import type { ResolveFn } from '../types.js';

export const resolvePass: ResolveFn = (b, roll, state) => {
  if (state.phase === 'COME_OUT') {
    if (roll.total === 7 || roll.total === 11) {
      return { betId: b.id, outcome: 'win', payout: b.amount };
    }
    if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
      return { betId: b.id, outcome: 'lose', payout: 0 };
    }
    return { betId: b.id, outcome: 'continue', payout: 0 };
  }
  if (roll.total === state.point) {
    return { betId: b.id, outcome: 'win', payout: b.amount };
  }
  if (roll.total === 7) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};

export const resolveDontPass: ResolveFn = (b, roll, state, rules) => {
  if (state.phase === 'COME_OUT') {
    if (roll.total === 7 || roll.total === 11) {
      return { betId: b.id, outcome: 'lose', payout: 0 };
    }
    if (roll.total === rules.dontPassPushOn) {
      return { betId: b.id, outcome: 'push', payout: 0 };
    }
    if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
      return { betId: b.id, outcome: 'win', payout: b.amount };
    }
    return { betId: b.id, outcome: 'continue', payout: 0 };
  }
  if (roll.total === state.point) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  if (roll.total === 7) {
    return { betId: b.id, outcome: 'win', payout: b.amount };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
